import { Component, inject } from '@angular/core';

import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet, Scroll } from '@angular/router';

import { fade } from './animations';
import { ChangeDetectionStrategy } from '@angular/core';
import { filter, pairwise } from 'rxjs';
import { ViewportScroller } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fade],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent {
  #router = inject(Router);
  #viewportScroller = inject(ViewportScroller);

  constructor() {
    this.#handleScrollOnNavigation();
  }

  #handleScrollOnNavigation(): void {
    this.#router.events
      .pipe(
        // import { Event } from '@angular/router'
        takeUntilDestroyed(),
        filter(e => e instanceof Scroll),
        pairwise()
      )
      .subscribe((e: Scroll[]) => {
        const previous = e[0];
        const current = e[1];

        if (current.position) {
          // Backward navigation
          this.#viewportScroller.scrollToPosition(current.position);
        } else if (current.anchor) {
          // Anchor navigation
          this.#viewportScroller.scrollToAnchor(current.anchor);
        } else if (previous.routerEvent instanceof NavigationEnd && current.routerEvent instanceof NavigationEnd) {
          // Check if routes match, or if it is only a query param change
          if (this.#getBaseRoute(previous.routerEvent.urlAfterRedirects) !== this.#getBaseRoute(current.routerEvent.urlAfterRedirects)) {
            // Routes don't match, this is actual forward navigation
            // Default behavior: scroll to top
            this.#viewportScroller.scrollToPosition([0, 0]);
          } else if (this.#getChildNode(this.#router.routerState.snapshot.root).data['scrollToTop']) {
            // get route data
            this.#viewportScroller.scrollToPosition([0, 0]);
          }
        }
      });
  }

  #getBaseRoute(url: string): string {
    // return url without query params
    return url.split('?')[0];
  }
  #getChildNode(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    if (route.firstChild) {
      return this.#getChildNode(route.firstChild);
    }
    return route;
  }
}
